class AllBrands extends HTMLElement {
  connectedCallback() {
    this.offset = parseInt(this.dataset.headerOffset || "72", 10);
    this.active = false;

    // Elements
    this.form = this.querySelector("[data-search-form]");
    this.input = this.form?.querySelector('input[name="q"]');
    this.searchIcon = this.form?.querySelector("[data-search-icon]");
    this.clearSearchBtn = this.form?.querySelector("[data-clear-search]");

    this.filterBar = this.querySelector("[data-filter-bar]");
    this.filterTerm = this.querySelector("[data-filter-term]");
    this.clearBtn = this.querySelector("[data-clear]");

    this.brandsStart = this.querySelector("[data-brands-start]");
    this.letterButtons = Array.from(
      this.querySelectorAll("button[data-letter]")
    );
    this.letterSections = Array.from(
      this.querySelectorAll("[data-letter-section]")
    );
    this.brandLinks = Array.from(this.querySelectorAll("[data-brand-name]"));

    if (this.form) {
      this.form.addEventListener("submit", (e) => this.onSubmit(e));
    }
    if (this.clearBtn) {
      this.clearBtn.addEventListener("click", () =>
        this.clearFilter({ scroll: true })
      );
    }
    if (this.clearSearchBtn) {
      this.clearSearchBtn.addEventListener("click", () =>
        this.clearFilter({ scroll: false })
      );
    }
    this.letterButtons.forEach((btn) =>
      btn.addEventListener("click", (e) => this.onLetterClick(e))
    );
    if (this.input) {
      this.input.addEventListener("input", () => this.onInputChange());
    }

    this.updateIcons();
  }

  onSubmit(e) {
    e.preventDefault();
    const term = (this.input?.value || "").trim();
    if (!term) {
      this.clearFilter({ scroll: true });
      return;
    }
    this.applyFilter(term);
  }

  onInputChange() {
    // Toggle icons while typing, but do not change filter until submit
    const hasText = !!(this.input && this.input.value.trim().length > 0);
    if (this.clearSearchBtn)
      this.clearSearchBtn.classList.toggle("hidden", !(hasText || this.active));
    if (this.searchIcon)
      this.searchIcon.classList.toggle("hidden", hasText || this.active);
  }

  applyFilter(term) {
    const q = term.toLowerCase();
    this.active = true;

    // Filter brand links by name
    this.brandLinks.forEach((a) => {
      const name = (a.dataset.brandName || "").toLowerCase();
      const match = name.includes(q);
      a.classList.toggle("hidden", !match);
    });

    // Hide sections with no visible brands
    this.letterSections.forEach((section) => {
      const visible =
        section.querySelectorAll("[data-brand-name]:not(.hidden)").length > 0;
      section.classList.toggle("hidden", !visible);
    });

    // Update buttons based on filtered visibility
    const visibleByLetter = new Map();
    this.letterSections.forEach((section) => {
      const letter = section.dataset.letterSection;
      const count = section.classList.contains("hidden")
        ? 0
        : section.querySelectorAll("[data-brand-name]:not(.hidden)").length;
      visibleByLetter.set(letter, count);
    });
    this.letterButtons.forEach((btn) => {
      const letter = btn.dataset.letter;
      const count = visibleByLetter.get(letter) || 0;
      if (count === 0) {
        btn.setAttribute("disabled", "true");
        btn.classList.add("opacity-50");
      } else {
        btn.removeAttribute("disabled");
        btn.classList.remove("opacity-50");
      }
    });

    // Show filter pill
    if (this.filterBar && this.filterTerm) {
      this.filterTerm.textContent = term;
      this.filterBar.classList.remove("hidden");
    }

    // Icons
    this.updateIcons();

    // Scroll to list start
    if (this.brandsStart) this.scrollWithOffset(this.brandsStart);
  }

  clearFilter(opts = { scroll: true }) {
    const { scroll } = opts;
    this.active = false;

    if (this.input) {
      this.input.value = "";
      this.input.focus();
    }

    this.brandLinks.forEach((a) => a.classList.remove("hidden"));
    this.letterSections.forEach((section) =>
      section.classList.remove("hidden")
    );

    this.letterButtons.forEach((btn) => {
      const hasBrands = btn.dataset.hasBrands === "true";
      if (hasBrands) {
        btn.removeAttribute("disabled");
        btn.classList.remove("opacity-50");
      } else {
        btn.setAttribute("disabled", "true");
        btn.classList.add("opacity-50");
      }
    });

    if (this.filterBar) this.filterBar.classList.add("hidden");

    this.updateIcons();

    if (scroll && this.brandsStart) this.scrollWithOffset(this.brandsStart);
  }

  updateIcons() {
    const showClear =
      this.active || (this.input && this.input.value.trim().length > 0);
    if (this.clearSearchBtn)
      this.clearSearchBtn.classList.toggle("hidden", !showClear);
    if (this.searchIcon) this.searchIcon.classList.toggle("hidden", showClear);
  }

  onLetterClick(e) {
    const btn = e.currentTarget;
    if (btn.hasAttribute("disabled")) return;
    const letter = btn.dataset.letter;
    const target = this.querySelector(`#brand-letter-${letter}`);
    if (target) {
      e.preventDefault();
      this.scrollWithOffset(target);
    }
  }

  scrollWithOffset(el) {
    const rect = el.getBoundingClientRect();
    const absoluteTop = rect.top + window.pageYOffset;
    const top = absoluteTop - this.offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
}
customElements.define("all-brands", AllBrands);
